import { render, staticRenderFns } from "./bossMange.vue?vue&type=template&id=e9d2caa8&scoped=true&"
import script from "./bossMange.vue?vue&type=script&lang=js&"
export * from "./bossMange.vue?vue&type=script&lang=js&"
import style0 from "./bossMange.vue?vue&type=style&index=0&id=e9d2caa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d2caa8",
  null
  
)

export default component.exports